import { render } from "./ManageFeatures.vue?vue&type=template&id=40a85f7b&scoped=true"
import script from "./ManageFeatures.vue?vue&type=script&lang=js"
export * from "./ManageFeatures.vue?vue&type=script&lang=js"

import "./ManageFeatures.vue?vue&type=style&index=0&id=40a85f7b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a85f7b"]])

export default __exports__